package horcrux.frontend.common.views.org

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.views.feedbackform.FEEDBACK_MESSAGE
import horcrux.frontend.common.views.feedbackform.FeedbackFormAndSubmit
import horcrux.frontend.common.views.feedbackform.FeedbackType
import kotlinx.browser.window
import mui.material.Button
import mui.material.Container
import mui.material.Stack
import mui.material.StackDirection
import mui.system.responsive
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.h3
import react.router.useNavigate
import web.cssom.AlignItems
import web.cssom.pt

external interface ContactUsProps : Props {
    var globalAppState: GlobalAppState
}

val ContactUs = FC<ContactUsProps> { props ->
    val navigate = useNavigate()
    Container {
        this.maxWidth = "xs"
        Stack {
            this.direction = responsive(StackDirection.column)
            this.sx {
                this.alignItems = AlignItems.center
            }
            h3 { +FEEDBACK_MESSAGE }

            FeedbackFormAndSubmit {
                this.feedbackType = FeedbackType.FEEDBACK
                this.globalAppState = props.globalAppState
                this.navigate = navigate
            }

            h3 { +"Or reach out to us on our socials" }

            for ((label, url) in StaticContentConfigs.CONTACT_URL_BY_LABEL) {
                Button {
                    +label
                    this.id = "$label-contact"
                    this.href = url
                    this.onClick = {
                        it.preventDefault()
                        window.open(url, "_blank", "noreferrer")
                    }
                    this.sx {
                        this.marginBottom = 5.pt
                    }
                }
            }
        }
    }
}
